<template>
  <div class="Introduce_wrap">
    <div class="content">
      <div class="list_wrap">
        <table  border="1" style="border-collapse:collapse;">
          <tr class="list" v-for="(item,index) in list" :key="index">
            <td class="item"><div class="title_tr">{{item.companyName}}</div></td>
            <td class="item"><a :href="item.companyUrl" style="text-decoration:none;">{{item.companyUrl}}</a></td>
            <td class="item"><button @click="copyFun(item.companyUrl)">复制推广链接</button></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      // list:[
      //   {
      //     title:'现代财产保险（中国）有限公司',
      //     url:'https://www.hi-ins.com.cn/hi/mall'
      //   },
      //   {
      //     title:'现代财产保险（中国）有限公司',
      //     url:'https://www.hi-ins.com.cn/hi/mall'
      //   },
      //   {
      //     title:'现代财产保险（中国）有限公司',
      //     url:'https://www.hi-ins.com.cn/hi/mall'
      //   },
      //   {
      //     title:'现代财产保险（中国）有限公司',
      //     url:'https://www.hi-ins.com.cn/hi/mall'
      //   },

      // ]
    }
  },
  computed:{
    list(){
      return JSON.parse(localStorage.getItem('introduceData')) 
    }
  },
  methods:{
    copyFun(copyText){
      const input = document.createElement('input')
      input.value = copyText
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
       this.$message({
        message:'复制成功！',
        type:'success',
        duration:1500
       });
    }
  }
}
</script>

<style lang="scss" scoped>
.Introduce_wrap{
  padding-bottom: 150px;
  display: flex;
  justify-content: center;
  .list_wrap{
    margin-top: 100px;
    .list{
      .item{
         padding: 5px 10px;
         border-style: dotted;
      }
      .title_tr{
        display: flex;
        align-items: center;
      }
    }
  }
}

</style>